import { API } from '@Providers';
interface AddDiscountPayload {
  code: string;
  item_id: string;
  target_item: string; // TODO :: TASK-980 Replace this for enum that matches the one in the API
}

export default async function (payload: AddDiscountPayload) {
  const endpoint = '/api/shelter/cart/add-item-discount/';

  return API({ endpoint, method: 'put', payload });
}
